import type { AiChatMessageRating } from '../../analytics/types/analytics-events.ts';

export type AskPlatoMessageRating = 'like' | 'dislike';

export type MessageRatingPress = {
    rating: AskPlatoMessageRating | undefined;
    reported: AiChatMessageRating;
};

export function pressMessageRating(
    current: AskPlatoMessageRating | undefined,
    pressed: AskPlatoMessageRating,
): MessageRatingPress {
    const rating = current === pressed ? undefined : pressed;

    return { rating, reported: rating ?? 'none' };
}
